import React from 'react';
import { Target, Zap, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import './About.css';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="about-enhanced">
          <div className="about-header-section">
            <h2 className="about-main-title">{t.about.title}</h2>
          </div>

          <div className="about-grid">
            <div className="about-primary-card">
              <div className="card-accent"></div>
              <div className="card-content">
                <Target size={32} className="card-icon" />
                <p className="card-text-large">{t.about.text1}</p>
              </div>
            </div>

            <div className="about-secondary-cards">
              <div className="about-mini-card">
                <Zap size={24} className="mini-card-icon" />
                <p className="card-text-medium">{t.about.text2}</p>
              </div>
              
              <div className="about-mini-card about-mini-card-highlight">
                <Shield size={24} className="mini-card-icon" />
                <p className="card-text-medium">{t.about.text3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
